import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Page } from "./types";
import React, { Suspense } from "react";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import LinearProgress from "@mui/material/LinearProgress";
import SiteHeader from "containers/SiteHeader";
import PageHome from "containers/PageHome/PageHome";
import PageLoginCont from "containers/PageLogin/PageLoginCont";
import Review from "containers/Review/Review";
//
import ProtectedRoute from "utils/ProtectedRoute";
//
const PageSearch = React.lazy(() => import("containers/PageSearch"));
const PageSubcription = React.lazy(
  () => import("containers/PageSubcription/PageSubcription")
);
const PageAbout = React.lazy(() => import("containers/PageAbout/PageAbout"));
const Rentals = React.lazy(() => import("components/rentals/Rentals"));
const PageContact = React.lazy(
  () => import("containers/PageContact/PageContact")
);

const Page404 = React.lazy(() => import("containers/Page404/Page404"));
//
//
//
const PrivacyPoli = React.lazy(
  () => import("containers/PageAbout/PrivacyPoli")
);
const Allblog = React.lazy(() => import("components/CustomBlog/AllBlog"));
const Allproducts = React.lazy(
  () => import("components/allProducts/Allproducts")
);
const ProductDetailPage = React.lazy(
  () => import("containers/ProductDetailPage/ProductDetailPage")
);
const BuyUsed = React.lazy(() => import("components/buyused/BuyUsed"));
const BrandDetailPage = React.lazy(
  () => import("containers/PageHome/brands/BrandDetailPage")
);
const Sellused = React.lazy(() => import("components/sellused/Sellused"));
const UsedProductDetailPage = React.lazy(
  () => import("containers/ProductDetailPage/UsedProductDetailPage")
);
const DocumentUpload = React.lazy(
  () => import("components/userprofile/pages/DocumentUpload")
);
//
//
//
const BlogSingle = React.lazy(() => import("containers/BlogPage/BlogSingle"));
const Profile = React.lazy(
  () => import("components/userprofile/pages/Profile")
);

const MyVdo = React.lazy(() => import("virtual/MyVdo"));
const aboutus = React.lazy(() => import("containers/PageAbout/PageAbout"));

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  {
    path: "/used-machine-detail/:machine_id/:category/:subcategory/:brand/",
    component: UsedProductDetailPage,
  },
  //
  { path: "/search-implements/:query/", component: PageSearch },
  //
  { path: "/contact", component: PageContact },
  { path: "/subscription", component: PageSubcription },
  { path: "/aboutus", component: PageAbout },
  { path: "/privacy-policy", component: PrivacyPoli },
  //
  { path: "/enquireForm/:id/:product_name", component: PageContact },
  { path: "/rental", component: Rentals },
  { path: "/document-upload/:id/", component: DocumentUpload },
  { path: "/buy-used", component: BuyUsed },
  {
    path: "/new-implements/:id/:product_name/",
    component: ProductDetailPage,
  },
  { path: "/new-implements", component: Allproducts },
  { path: "/posts", component: Allblog },
  { path: "/login", component: PageLoginCont },
  { path: "/reviews", component: Review },
];
//
//

const Loading = () => (
  <div className="container min-h-screen">
    <LinearProgress className="mt-2" />
  </div>
);

const Routes = () => {
  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      <SiteHeader />
      <Suspense fallback={<Loading />}>
        <Switch>
          {pages.map(({ component, path, exact }) => {
            return (
              <Route
                key={path}
                component={component}
                exact={!!exact}
                path={path}
              />
            );
          })}
          <Route path="/blog-single/:slug/" component={BlogSingle} />
          <Route path="/videos" component={MyVdo} />
          <ProtectedRoute path="/profile" component={Profile} />
          <ProtectedRoute path="/sell-used" component={Sellused} />
          <Route path="/aboutus" component={aboutus} />
          <Route path="/brand/kubota" component={BrandDetailPage} />
          <Route component={Page404} />
        </Switch>
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
};

export default Routes;
